import { Button, Dialog, DialogActions, DialogContentText, DialogTitle, IconButton, Typography } from '@mui/material';
import { Close } from '@mui/icons-material';
import { ExaminationMenuType } from '../types/ExaminationMenuType';

interface ErrorDialogProps {
  open: boolean;
  menu: ExaminationMenuType | null;
  submitHandler?: () => void;
  closeHandler?: () => void;
}

export const ExaminationMenuDialog = ({
  open,
  menu,
  submitHandler = () => {
    console.log('submitHandler is not defined');
  },
  closeHandler = () => {
    console.log('closeHandler is not defined');
  }
}: ErrorDialogProps) => {
  return (
    <Dialog open={open} aria-labelledby="menu-dialog-title" aria-describedby="menu-dialog-description" maxWidth={'xs'}>
      <IconButton
        onClick={closeHandler}
        aria-label="close"
        sx={{
          position: 'absolute',
          right: 8,
          top: 8
        }}
      >
        <Close />
      </IconButton>
      <DialogTitle id="menu-dialog-title" textAlign={'center'} fontSize={'13pt'} fontWeight={'bold'} marginTop={'20px'}>
        {menu?.outpatientName}
      </DialogTitle>
      <DialogContentText id="menu-dialog-description" paddingX={'24px'} marginBottom={'32px'}>
        <Typography fontSize={'11pt'} marginBottom={'0px'}>
          ◯保険適用/自由診療：
        </Typography>
        <Typography fontSize={'10pt'} marginTop={'0px'} marginBottom={'10px'} style={{ whiteSpace: 'pre-wrap' }}>
          {menu?.insuranceType}
        </Typography>
        <Typography fontSize={'11pt'} marginBottom={'0px'}>
          ◯所要時間の目安：
        </Typography>
        <Typography fontSize={'10pt'} marginTop={'0px'} marginBottom={'10px'} style={{ whiteSpace: 'pre-wrap' }}>
          {menu?.timeRequired}
        </Typography>
        <Typography fontSize={'11pt'} marginBottom={'0px'}>
          ◯費用：
        </Typography>
        <Typography fontSize={'10pt'} marginTop={'0px'} marginBottom={'10px'} style={{ whiteSpace: 'pre-wrap' }}>
          {menu?.cost}
        </Typography>
        <Typography fontSize={'11pt'} marginBottom={'0px'}>
          ◯外来説明：
        </Typography>
        <Typography fontSize={'10pt'} marginTop={'0px'} style={{ whiteSpace: 'pre-wrap' }}>
          {menu?.description}
        </Typography>
        <DialogActions>
          <Button
            className="bg-primary"
            variant="contained"
            fullWidth
            onClick={submitHandler}
            style={{ textAlign: 'center', marginTop: '16px', marginLeft: '36px', marginRight: '36px' }}
          >
            予約日時を選択する
          </Button>
        </DialogActions>
      </DialogContentText>
    </Dialog>
  );
};

export default ExaminationMenuDialog;
